
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M4 4h16v16H4z"}}),_c('path',{attrs:{"d":"M18 6.4H6c-.9 0-1.7.8-1.7 1.7v7.8c0 .9.8 1.7 1.7 1.7h12c.9 0 1.7-.8 1.7-1.7V8.1c0-.9-.8-1.7-1.7-1.7zm.6 1.7v2.7h-3.4V7.5H18c.3 0 .6.3.6.6zM6 7.5h8.1v3.3H5.4V8.1c0-.3.3-.6.6-.6zm-.6 8.4V12H11v4.5H6c-.3 0-.6-.3-.6-.6zm12.6.6h-5.9V12h6.5v3.9c0 .3-.3.6-.6.6z"}})])
          )
        }
      }
    